import { FiImage } from 'react-icons/fi';
import type { NavItem } from '@/app/config/navigation';

/**
 * Media module manifest.
 *
 * `content.mediaasset.read` and `content.mediaasset.create` are M44's own
 * permission codes, granted at the membership-role layer to every member of a
 * tenant (register §5). The media library is a CONTENT surface, so it is gated
 * by its permission and not by a capability id: the API authorizes these reads
 * by permission alone, and a capability gate here would be a mapping the server
 * does not make.
 */
export const MEDIA_READ_PERMISSION = 'content.mediaasset.read';
export const MEDIA_CREATE_PERMISSION = 'content.mediaasset.create';

export const MANIFEST = {
  id: 'media',
  routes: [
    { path: '/catalog/media', permission: MEDIA_READ_PERMISSION },
  ],
} as const;

export const NAV_ITEMS: ReadonlyArray<NavItem> = [
  {
    id: 'catalog.media',
    to: '/catalog/media',
    label: 'Media',
    group: 'Catalog',
    order: 32,
    permission: { require: [MEDIA_READ_PERMISSION] },
    icon: FiImage.name,
  },
];
